import { render, staticRenderFns } from "./Station.vue?vue&type=template&id=0a6c95d4&scoped=true"
import script from "./Station.vue?vue&type=script&lang=js"
export * from "./Station.vue?vue&type=script&lang=js"
import style0 from "./Station.vue?vue&type=style&index=0&id=0a6c95d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6c95d4",
  null
  
)

export default component.exports